// app/(main)/layout.tsx
'use client'

import React from 'react'

/**
 * ✅ Header는 최상단 app/layout.tsx에서 한 번만 렌더링됨
 * 라우트 그룹 전환 시에도 Header가 리마운트되지 않아 깜빡임 방지
 */
export default function MainLayout({ children }: { children: React.ReactNode }) {
  return (
    <>
      <main className="pt-[64px] w-full">
        <div className="w-full px-0">{children}</div>
      </main>
    </>
  )
}
